import { render } from "./UpdateCollection.vue?vue&type=template&id=3cee93fd&scoped=true"
import script from "./UpdateCollection.vue?vue&type=script&lang=js"
export * from "./UpdateCollection.vue?vue&type=script&lang=js"

import "@/Common/Styles/updateCollection.scss?vue&type=style&index=0&id=3cee93fd&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/THEOS-interfaces/THEOS-interfaces/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3cee93fd"]])

export default __exports__